import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "video-player-overlay-meta"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.eventItem)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.card)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.card.name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.watchLists, (watchList) => {
            return (_openBlock(), _createElementBlock("span", {
              key: watchList.id,
              class: "video-player-overlay-meta__marker",
              style: _normalizeStyle({ backgroundColor: '#' + watchList.color })
            }, null, 4))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedFeatures, (feature) => {
          return (_openBlock(), _createElementBlock("div", {
            key: feature.content
          }, _toDisplayString(feature.content), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}